/**
 * Notification Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InternalAlertDto { 
    type: InternalAlertDto.TypeEnum;
    deviceId?: number;
    detectionTime: string;
    level: InternalAlertDto.LevelEnum;
    additionalMessage?: string;
}
export namespace InternalAlertDto {
    export const TypeEnum = {
        TrapFirmwareBugSpam: 'TRAP_FIRMWARE_BUG_SPAM',
        PositionLowFixRate: 'POSITION_LOW_FIX_RATE',
        IridiumTestPlanRunsOut: 'IRIDIUM_TEST_PLAN_RUNS_OUT',
        ReceivedMessageFromDeactivatedDevice: 'RECEIVED_MESSAGE_FROM_DEACTIVATED_DEVICE',
        RemoteCommandAcknowledgeCrcError: 'REMOTE_COMMAND_ACKNOWLEDGE_CRC_ERROR',
        UnknownFirmwareVersionParameter: 'UNKNOWN_FIRMWARE_VERSION_PARAMETER',
        IridiumTestPlanByteUsageReached: 'IRIDIUM_TEST_PLAN_BYTE_USAGE_REACHED'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const LevelEnum = {
        Level1: 'LEVEL_1',
        Level2: 'LEVEL_2'
    } as const;
    export type LevelEnum = typeof LevelEnum[keyof typeof LevelEnum];
}


export type TypeEnum = typeof InternalAlertDto.TypeEnum[keyof typeof InternalAlertDto.TypeEnum];
export type LevelEnum = typeof InternalAlertDto.LevelEnum[keyof typeof InternalAlertDto.LevelEnum];
